<template>
    <Button label="Atualizar" icon="pi pi-pencil" @click="toAtualizar()" class="ml-2" />
</template>

<script>
export default {
    props: {
        participante: {
            type: Object,
        },
    },

    methods: {
        toAtualizar() {
            this.$router.push({
                name: 'Checkins_Eventos_Participantes_Atualizar',
                params: {
                    participanteId: this.participante.participanteId,
                },
            });
        },
    },
};
</script>
